// Home Insurance Policy Constants and Data
import cancelPolicy from "../../assets/images/cancelPolicy.svg";
import refreshIcon from "../../assets/images/refresh-dark.svg";

// Home Insurance-specific action type constants
export const CANCEL_POLICY_HOME_INSURANCE = "CANCEL_POLICY_HOME_INSURANCE";

// Home Insurance Policy Overview Data
export const homeInsurancePolicyOverview = {
  policyInfo: {
    policy_label: "Your Home Insurance Policy",
    policy_label_ar: "وثيقة تأمين المنزل",
    status: "Active",
    status_ar: "نشيط",
    planName: "Home Insurance Policy",
    planName_ar: "وثيقة تأمين المنزل",
    policyNumber: "",
    date: {
      startDate: "",
      endDate: "",
    },
    btn: {
      icon: refreshIcon,
      btn_lable_en: "Renew Policy",
      btn_lable_ar: "تجديد الوثيقة",
    },
  },
  cards: [
    {
      icon: "",
      value: "24/7 Support",
      value_ar: "دعم على مدار الساعة",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Property Coverage",
      value_ar: "تغطية العقار",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    },
    {
      icon: "",
      value: "Contents Coverage",
      value_ar: "تغطية المحتويات",
      call_option: {
        icon: "",
        lable_en: "Call +973 17223351",
        label_ar: "+973 اتصل على 17223351",
        phone: "+97317223351"
      }
    }
  ]
};

// Home Insurance Policy Manage Actions (only Cancel Policy)
export const manageHomeInsurancePolicy = {
  cards: [
    {
      icon: cancelPolicy,
      value: "Cancel Policy",
      value_ar: "إلغاء السياسة",
      type: CANCEL_POLICY_HOME_INSURANCE
    }
  ]
};

// Home Insurance Benefits
export const homeInsuranceBenefits = [
  "Building Structure Protection",
  "Personal Contents Coverage",
  "Natural Disasters Coverage",
  "Theft and Burglary Protection",
  "24/7 Claims Support"
];

// Function to filter cards for home insurance (only cancel policy)
export const getFilteredHomeInsuranceCards = (policyDetails) => {
  return manageHomeInsurancePolicy.cards;
};